'use strict';

/**
 * Displays a toast notification with title, message, and SVG icon ID.
 *
 * @param {string} title - Notification title.
 * @param {string} message - Notification message.
 * @param {string} iconId - SVG icon ID (e.g., 'success-icon', 'error-icon').
 * @param {string} caller - Copy url.
 */
function showNotification(title, message, iconId, caller) {
    const $notif = $('#globalNotification');
    const $bagIcon = $notif.find('.bag-icon');
    const $iconUse = $notif.find('#notif-icon');
    $notif.find('#notif-title, #notif-msg').text('');

    if (document.querySelector(`svg symbol#${iconId}`)) {
        $iconUse.attr('xlink:href', `#${iconId}`);
        $bagIcon.removeClass('d-none');
    } else {
        $bagIcon.addClass('d-none');
    }

    $notif.find('#notif-title').text(title);
    $notif.find('#notif-msg').text(message);
    if (caller && caller.urlButton) {
        $('.bag-message').addClass('align-items-center');
    }
    $notif.removeClass('hidden');

    setTimeout(() => {
        $notif.addClass('hidden');
    }, 5000);
}

/**
 * Displays a temporary add/remove product notification in the global notification container.
 * @param {string} cartAddedTitle - The title or message to display inside the notification.
 * @example
 * @param {string} message - The text content of the notification body shown under the title.
 * productAddRemoveNotification('Product added to cart');
 */
function productAddRemoveNotification(cartAddedTitle, message) {
    const $notif = $('#globalNotification');
    $notif.find('#notif-title').text(cartAddedTitle);
    $notif.find('#notif-msg').text(message);
    $notif.removeClass('hidden');
    setTimeout(() => {
        $notif.addClass('hidden');
    }, 5000);
}
module.exports = {
    showNotification: showNotification,
    productAddRemoveNotification: productAddRemoveNotification
};

